import { render } from "./ImageEdit.vue?vue&type=template&id=8fc41ef6&scoped=true"
import script from "./ImageEdit.vue?vue&type=script&lang=js"
export * from "./ImageEdit.vue?vue&type=script&lang=js"

import "./ImageEdit.vue?vue&type=style&index=0&id=8fc41ef6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc41ef6"]])

export default __exports__